import { Helmet } from "react-helmet";
import BreadCrumb from "../components/Breadcrumb";
import classes from "./TermsAndConditions.module.css";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
  return (
    <>
      <Helmet>
        <title>
          Terms & Conditions - TechMatter UK Online IT Hardware Purchases
        </title>
        <meta
          name="description"
          content="Read the comprehensive Terms & Conditions of TechMatter UK, covering purchase guidelines, responsibilities, and online shopping rules for servers, PCs, and networking products."
        />
        <link
          rel="canonical"
          href="https://techmatter.co.uk/terms-conditions"
        />
      </Helmet>

      <BreadCrumb currentPage="Terms and Conditions" />
      <div className={`container ${classes.TermsAndConditionsContainer}`}>
        <p className={classes.paragraph}>
          Want to order from TechMatter? Read our terms and conditions carefully
          for a better insight into our customer service policies. It contains
          detailed information regarding your rights, obligations, conditions,
          and limitations.
        </p>
        <h2 className={classes.subheading}>
          1. Rights as a Business Consumer or Business Customer:
        </h2>
        <p className={classes.paragraph}>
          You get different rights in accordance with whether you are a business
          customer or a business consumer.
        </p>
        <p className={classes.paragraph}>
          <strong>Business Customer: </strong>you will be classified as a
          business customer if you are not the end-user of the goods you bought
          from us e.g. Using these products for your trade or business.
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>Business Customer: </strong>You are the end-user of the
          product you bought e.g. not using it for your business entities or
          organization.
        </p>
        <p className={classes.paragraph}>
          <strong>1.2 Our Terms:</strong>
        </p>
        <p className={classes.paragraph}>
          Following are the terms and conditions related to our products and
          services including goods and virtual products along with the digital
          licenses and support contracts.
        </p>
        <ul>
          <li className={classes.list}>
            <strong>CONDITIONS: </strong>Our sales terms and conditions are
            outlined in this document, and this includes any special conditions
            unless stated otherwise. Special Conditions refer to additional
            conditions written in an order or quotation and considered part of
            the contract.
          </li>
          <li className={classes.list}>
            <strong>CONTRACT: </strong>refers to the contract to buy or sell the
            goods, in accordance with the terms and conditions.
          </li>
        </ul>
        <p className={classes.paragraph}>
          <strong>1.3. GOODS:</strong> it refers to the goods/products we supply
          to you, their parts and installation, and related services in
          accordance with the Contract and Conditions.
        </p>
        <p className={classes.paragraph}>
          <strong>1.4. WE, US, or OUR:</strong> it refers to Techmatter.co.uk;
          (company number 11329608).
        </p>
        <p className={classes.paragraph}>
          <strong>1.5. WEBSITE:</strong> our website{" "}
          <Link to="https://techmatter.co.uk">https://techmatter.co.uk</Link>
        </p>
        <p className={classes.paragraph}>
          <strong>1.6. WRITING:</strong> includes all electronic forms of
          communication or transmission, except for notices sent to cancel or
          terminate a Contract which must be sent by registered post or fax
          (with a fax transmission confirmation sheet retained).
        </p>
        <p className={classes.paragraph}>
          <strong>1.7. YOU or YOUR:</strong> the term refers to the person whose
          order for the goods is accepted by us according to the process
          outlined in these conditions.
        </p>
        <p className={classes.paragraph}>
          <strong>1.8. WEEE:</strong> refers to waste electrical and electronic
          equipment as defined in the WEEE Regulations.
        </p>
        <p className={classes.paragraph}>
          <strong>1.9. WEEE Regulations:</strong> The Waste Electrical and
          Electronic Regulations 2006 (SI 2006/3289)
        </p>
        <h2 className={classes.subheading}>2. Contact us</h2>
        <p className={classes.paragraph}>
          <strong>2.1. </strong> You can reach us through our web chat tool, by
          emailing our customer service team at{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>{" "}
          by calling <Link to="tel:+442031293546">+44 20 3129 3546</Link>
        </p>
        <p className={classes.paragraph}>
          <strong>2.2. </strong> If we need to reach you, we will use the
          contact information provided in your order, including your phone
          number, email address, and postal address.
        </p>
        <h2 className={classes.subheading}>3. Basis of the sale</h2>
        <p className={classes.paragraph}>
          <strong>3.1. </strong> When you place an order with us, we will sell
          you the Goods in accordance with your request, provided it is accepted
          by us following the process outlined in these Conditions. These
          Conditions will always apply to your order and form the basis of the
          Contract between us. Please refrain from including your own terms and
          conditions with your order, as we will not accept them and they will
          not apply to the Contract. Any quotation or estimate we provide is
          merely indicative and cannot be accepted by you as an offer from us.
        </p>
        <p className={classes.paragraph}>
          <strong>3.2. </strong> These conditions cannot be altered unless
          authorized representatives from both parties agree in writing.
          Declining to enter into a Contract under your own terms does not
          override this clause or the previous one, and we still reserve the
          right to collect payment for the Goods from you.
        </p>
        <p className={classes.paragraph}>
          <strong>3.3. </strong> We may offer you guidance concerning the Goods,
          including their use and suitability for your specific needs. We take
          full responsibility for the advice we provide you with in relation to
          the Goods, but only if you have accurately and thoroughly described
          your requirements and the intended purpose of the Goods. Our advice
          will align with the information you have shared with us.
        </p>
        <p className={classes.paragraph}>
          <strong>Clause 3.4. </strong> states that, other than what is
          described in clause 3.3, you recognize that (i) our employees,
          servants, or agents are not permitted to give advice or make any
          statements about the Goods unless confirmed by one of our authorized
          representatives in writing and (ii) you have not relied on any such
          advice, representation or statement when entering into the Contract.
          Unless they are specifically included in writing within the Contract,
          you agree not to make any claim for breach of such advice,
          representation, or statement. However, it is important to note that
          neither party’s liability is affected by these Conditions for
          statements made fraudulently.
        </p>
        <p className={classes.paragraph}>
          <strong>3.5. </strong> We provide information about our products and
          their availability through various materials such as advertisements,
          catalogs, price lists, images, illustrations, or other similar
          materials that can be accessed through our website. Although we strive
          to ensure that this information is accurate to the best of our
          knowledge, we cannot guarantee that it is always 100% accurate. In
          case the information turns out to be less accurate or different, we
          will not be held liable to you for any errors (unless it is
          specifically stated in our conditions).
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>3.6. </strong> In case of any errors in our sales literature,
          quotations, price lists, acceptance of offers, invoices, or any other
          documents or information provided by us (including those displayed on
          the website), we reserve the right to correct them without incurring
          any liability to you, unless otherwise stated in these conditions.
        </p>
        <p className={classes.paragraph}>
          <strong>3.7. </strong> As part of our Contract, some of the hardware
          or software we provide may be subject to legal restrictions. These
          restrictions may be imposed by the country or state where the product
          was made or sent from, or they may be related to third-party
          Intellectual Property rights or license agreements with third parties.
          By accepting the Contract, you agree to comply with any applicable
          legal controls, third-party rights, or license agreements and agree
          not to breach them. Furthermore, if you do breach any of these terms,
          you agree to hold us harmless against any consequences resulting from
          the breach, including actions taken by anyone who obtains the product
          from you after delivery.
        </p>
        <h2 className={classes.subheading}>4. Orders and specifications</h2>
        <p className={classes.paragraph}>
          <strong>4.1. </strong> To purchase the Goods, you can submit your
          order through the Website, via email, or in writing. Your order should
          include the types and quantities of Goods you need, your delivery
          address, and contact details of the person we can reach out to
          regarding your order. This information is required as part of the
          online ordering process. By placing an order, you are offering to buy
          the Goods based on these Conditions.
        </p>
        <p className={classes.paragraph}>
          <strong>4.2. </strong> To ensure that any order you place with us is
          binding, it must be accepted by one of our authorized representatives,
          at our sole discretion. If you submit an order through our website, we
          will acknowledge it by sending an official “Shipping Confirmation”
          email. This email serves as proof that a binding contract has been
          concluded between you and us, under these conditions. You may receive
          an “acknowledgment of order receipt” email after submitting your
          order, but this does not mean that your order has been accepted. It
          simply acknowledges that we have received your order and are checking
          to see if we can accept it. For confirmation of the order, we will
          email you to confirm our acceptance, which is when the contract is
          created between you and us.
        </p>
        <p className={classes.paragraph}>
          <strong>4.3. </strong> Please ensure that the terms of your order,
          including any necessary specifications, are accurate and complete.
          Also, kindly provide us with all the required information regarding
          the Goods in advance so that we can proceed with the Contract as per
          its terms.
        </p>
        <p className={classes.paragraph}>
          <strong>4.4. </strong> The Goods’ quantity, quality, description, and
          any specifications shall be as per your order (once accepted by us as
          per the process mentioned in these Conditions), which may also refer
          to the Goods as described on the Website during the order placement.
        </p>
        <p className={classes.paragraph}>
          <strong>4.5. </strong> If you provide us with a specific set of
          instructions or specifications for manufacturing or altering the
          Goods, you agree to protect us from any damages, losses, costs, or
          expenses that may arise from any claims made by third parties
          regarding the infringement of their rights.
        </p>
        <p className={classes.paragraph}>
          <strong>4.6. </strong> We can modify the Goods’ specification to
          comply with safety or legal regulations or if it doesn’t affect its
          quality or performance.
        </p>
        <p className={classes.paragraph}>
          <strong>4.7. </strong> If you want to cancel or modify your order, you
          can contact before we confirm it. We’ll inform you if your requested
          changes are feasible. If they are, we’ll also let you know if there
          will be any changes to the price of the goods, the delivery date, or
          anything else that may be affected. We’ll ask you to confirm whether
          you want to make the changes.
        </p>
        <p className={classes.paragraph}>
          <strong>4.8. </strong> If you decide to cancel your order, we will
          promptly refund any money that you have already paid for it.
          Alternatively, if no money has been paid but you have been invoiced
          for the canceled portion of the order, we will issue a credit note to
          you. If you make changes to your order such as substituting new goods
          or altering quantities, there may be a difference in payment between
          the original and amended order. In this case, the difference must be
          settled as soon as possible by either paying us the difference or
          having us repay or credit the difference to you, as appropriate.
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>4.9. </strong> No order can be canceled by you unless
          following Clause 10.
        </p>
        <p className={classes.paragraph}>
          <strong>4.10. </strong> If we suspect you of engaging in fraudulent,
          illegal, or other improper activity in placing an order or in your
          interactions with us, we reserve the right to cancel the order or
          terminate any Contract. Please note that if we have reasonable
          suspicion of illegal activity, we may have to report it to the
          appropriate authorities without notifying you.
        </p>
        <h2 className={classes.subheading}>5. Price of the goods</h2>
        <p className={classes.paragraph}>
          <strong>5.1. </strong> The price of the Goods shall be our quoted
          price for the relevant Goods as at the time of our acceptance of your
          order following the process set out in these Conditions. For Goods
          ordered online, that price will be the one set out in our
          “acknowledgement of order receipt” e-mail to you. For other orders the
          price will be the one communicated to you in writing, usually in our
          sales quotation sent to you. This price shall apply to the Contract in
          spite of any other price which may have appeared on the Website or may
          have been notified to you before our acceptance of your order. Prices
          listed on our Website are shown with and without VAT. Prices listed in
          our sales quotations are exclusive of VAT.
        </p>
        <p className={classes.paragraph}>
          <strong>5.2. </strong> Despite our best efforts, it is possible for
          some of our products to be incorrectly priced. We will check our
          prices before accepting your order to ensure their validity. If the
          product’s correct price at your order date is higher than the price
          listed on our Website or otherwise communicated to you, we will
          contact and notify you and request your instructions before we accept
          your order. If we accept and process your order where a pricing error
          is obvious and unmistakable and could reasonably have been recognized
          by you as a mispricing, we may terminate the Contract, refund you any
          sums you have paid and require the return of any Goods provided to
          you.
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>5.3. </strong> Sometimes, the cost of Goods to us can increase
          due to a factor beyond our reasonable control (such as, without
          limitation, any foreign exchange fluctuation, currency regulation,
          alteration of duties, significant increases in the costs of labour,
          materials or any other costs of manufacture, any significant change in
          delivery dates, delivery address, quantities or specifications for the
          Goods which is requested by you, or any delay caused by any of your
          instructions, or failure of you to give us adequate information or
          instructions). In such an event, we may need to increase the price of
          the Goods to you prior to delivery. If this happens, we will notify
          you accordingly and request your instructions before processing your
          order. We reserve the right to terminate the Contract in the event
          that we cannot recover the increased costs from you.
        </p>
        <p className={classes.paragraph}>
          <strong>5.4. </strong> Unless we have agreed in writing with you
          otherwise, all prices quoted do not include the cost of delivery of
          the Goods to your premises. Delivery costs are displayed and applied
          during checkout on our Website and are also specified in sales
          quotations we supply to you.
        </p>
        <h2 className={classes.subheading}>6. Payment terms</h2>
        <p className={classes.paragraph}>
          <strong>6.1. </strong> Unless we have agreed with you in writing
          otherwise, you will be required to pay for all Goods through the
          Website (free from any right of set off, counterclaim, withholding or
          deduction of any kind, those rights being specifically excluded) using
          the secure online payment facilities. During the order process you
          will need a credit or debit card registered to an address in the UK or
          the Republic of Ireland. Credit or other account terms may be offered
          to you, but the offering of such credit facilities shall be at our
          absolute discretion.
        </p>
        <p className={classes.paragraph}>
          <strong>6.2. </strong> Where credit terms have been offered to you,
          then subject to any other Special Conditions, we shall be entitled to
          invoice you for the price of the Goods upon dispatch of the Goods from
          our premises (or those of the third party delivering the Goods on our
          behalf).
        </p>
        <p className={classes.paragraph}>
          <strong>6.3. </strong> Where credit terms have been offered to you,
          then you shall pay the price of the Goods in full and cleared funds
          (free from any right of set off, counterclaim, withholding or
          deduction of any kind, those rights being specifically excluded) on
          the date stated on the front of the sales invoice (or if no date is
          stated on the invoice, within thirty (30) days of the date of our
          invoice) even though delivery may not have taken place and the
          property in the Goods may not have passed to you.
        </p>
        <p className={classes.paragraph}>
          <strong>6.4. </strong> For all Contracts concluded on these
          Conditions, the time of payment of the price of the Goods shall be of
          the essence of the Contract. Receipts for payment will be issued only
          upon request.
        </p>
        <p className={classes.paragraph}>
          <strong>6.5. </strong> If you fail to make any payment in full and
          cleared funds on the date it is due to us then, without limiting our
          other options to protect ourselves from this situation, we shall be
          entitled to:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>6.5.1. </strong> cancel the Contract (and / or any other
            contract between you and us);
          </p>

          <p className={classes.paragraph}>
            <strong>6.5.2. </strong> suspend any further deliveries of the Goods
            (and / or the goods supplied under any other contract between you
            and us) to you, except upon receipt of cash or other security
            satisfactory to us;
          </p>

          <p className={classes.paragraph}>
            <strong>6.5.3. </strong> apply any payment made by you to such of
            the Goods (or the goods supplied under any other contract between
            you and us) as we may think fit; and / or
          </p>
          <p className={classes.paragraph}>
            <strong>6.5.4. </strong> charge you interest (both before and after
            any judgement) on the amount unpaid, at the rate of four per cent
            (4%) per year above National Westminster Bank Plc’s base rate from
            time to time, from the due date for payment until full payment is
            made (a part of a month being treated as a full month for the
            purpose of calculating interest).
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>6.6. </strong> Even where credit terms have been agreed with
          you, special orders may require payment in advance by you.
        </p>
        <p className={classes.paragraph}>
          <strong>6.7. </strong> Where the Goods are supplied by instalments,
          you must pay for each instalment in accordance with the terms set out
          in this clause 6. Where no credit terms are offered to you, this may
          involve payment in full being made for all instalments of the Goods in
          advance of any instalment of the Goods being delivered to you (whether
          by pre-authorization of a credit card or otherwise). If we then fail
          to deliver any later instalment of the Goods to you, a refund of the
          price paid in advance by you for the failed instalment of the Goods
          will be made to you.
        </p>
        <p className={classes.paragraph}>
          <strong>6.8. </strong> We will, to settle all debts owing by you to us
          on any account, have a general lien on all goods and property
          belonging to you in our possession and shall be entitled, after
          fourteen (14) days’ notice to you, to dispose of those goods or
          property as we think fit and to apply any proceeds from selling them
          (after deducting our reasonable selling expenses) towards the payment
          of your debts to us.
        </p>
        <h2 className={classes.subheading}>7. Delivery</h2>
        <p className={classes.paragraph}>
          <strong>7.1. </strong> Delivery costs are listed during the checkout
          process on our website and are itemized on our sales quotations to you
          which precede your order to purchase Goods from us. We offer a range
          of delivery services and will communicate to you how and when we will
          deliver Goods to you.
        </p>
        <p className={classes.paragraph}>
          <strong>7.2. </strong> Unless we have agreed in writing that it will
          not, delivery of the Goods shall take place by us delivering the Goods
          to the delivery location set out in our “Shipping confirmation” e-mail
          (or such other premises as we may agree with you) during normal
          business hours. Delivery shall be complete once the Goods arrive at
          the delivery address. Again, unless we have agreed in writing that we
          will not, we shall bear the risk of loss of or damage to any
          consignment of the Goods until delivery to the delivery address and we
          will arrange for transport and insurance of the Goods in transit. In
          all cases, where we are to deliver the Goods to you, this may be done
          through our nominated courier or sub-contract or without any need for
          consent from you to their appointment. Please note that it is your
          responsibility to ensure that someone is available to sign for all
          deliveries. Failure to comply with this requirement shall not affect
          our obligation to deliver the Goods as advised which will be complete
          upon arrival of the Goods at the delivery address.
        </p>
        <p className={classes.paragraph}>
          <strong>7.3. </strong> Any periods or dates quoted for delivery of the
          Goods are approximate only and are not binding on us, but we shall try
          to meet them wherever possible. We shall not be liable for any delay
          in delivery of the Goods though and any such delay shall not be a
          breach of the Contract. We will contact you where possible to let you
          know of any delays and we will take steps to minimize the effect of
          the delay. If there is a risk of a substantial delay you may contact
          us to end the Contract and receive a refund for any products you have
          paid for but not received. The Goods may sometimes be delivered by us
          before the quoted delivery date.
        </p>
        <p className={classes.paragraph}>
          <strong>7.4. </strong> If no one is available at your address to take
          delivery and the Goods cannot be left securely at the address or
          posted through the letterbox, we may automatically reattempt delivery
          on the following business day. In the event of a failed delivery, we
          will normally leave you a note informing you of how to rearrange
          delivery or collect the Goods from your local courier depot.
        </p>
        <p className={classes.paragraph}>
          <strong>7.5. </strong> If you do not re-arrange delivery or collect
          the Goods following a failed delivery attempt we will contact you for
          further instructions and may charge you for any further delivery or
          storage costs we incur. If, despite our efforts, we are unable to
          contact you or re-arrange delivery or collection we reserve the right
          to end our Contract with you.
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>7.6. </strong> Where the Goods are to be delivered in
          instalments, each delivery shall make up a separate contract to which
          all of these Conditions apply. If we fail to deliver any one or more
          of the instalments in accordance with these Conditions (or you claim
          that we have failed to deliver one or more instalments) we both agree
          that this won’t be enough for you to cancel or terminate the whole
          Contract.
        </p>
        <p className={classes.paragraph}>
          <strong>7.7. </strong> If we fail to deliver the Goods for any reason
          other than one beyond our reasonable control or your fault, and we are
          accordingly liable to you, our liability shall be limited to the
          amount you have to pay (if any) in the cheapest available market above
          the agreed price of the Goods to obtain similar Goods to replace those
          not delivered.
        </p>
        <p className={classes.paragraph}>
          <strong>7.8. </strong> Any claim you might have which is based on a
          difference between the Goods ordered and those delivered shall
          (whether or not delivery is refused) be notified to us in writing
          within 48 hours from the time of delivery. Where you fail to notify us
          in this timeframe, we shall be deemed to have supplied the Goods in
          accordance with the quantities specified in the Contract, and shall
          have no liability to you for any such claim. Please refer to clauses
          11 & 12 for our terms relating to defective, incorrect and incomplete
          products.
        </p>
        <p className={classes.paragraph}>
          <strong>7.9. </strong> Applicable delivery charges will be charged at
          our standard rate unless otherwise agreed. Charges exclude VAT.
        </p>
        <p className={classes.paragraph}>
          <strong>7.10. </strong> If Goods are delivered to an incorrect address
          and the correct address has been stipulated on your order you must
          notify us within 48 hours of delivery in order for us to rectify the
          problem. Any incorrect deliveries notified after the 2-business day
          notification period will not usually be accepted. Any incorrect
          deliveries notified within the notification period and which were made
          due to an error by us will be collected at our own expense and our
          mistake corrected as soon as possible.
        </p>
        <p className={classes.paragraph}>
          <strong>7.11. </strong> If you receive Goods from us which have
          suffered from damage or loss in transit, we ask that you report it to
          us within 7 working days (please note that this is 48 hours for our
          business customers). If the Goods are visibly damaged on receipt, it’s
          important to sign the carrier’s delivery note accordingly to support
          the resolution process. If a picture can be taken of the condition at
          arrival this is also helpful. Transit damage claims may not be
          accepted if the delivery has not been signed for as damaged or unless
          proof of loss can otherwise be shown, or if you notify us outside of
          the period referred to above.
        </p>
        <h2 className={classes.subheading}>8. Risk and property</h2>
        <p className={classes.paragraph}>
          <strong>8.1. </strong> Risk of damage to or loss of the Goods shall
          pass to you:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>8.1.1. </strong> on completion of delivery of the Goods in
            accordance with these Conditions; or
          </p>

          <p className={classes.paragraph}>
            <strong>8.1.2. </strong> where you have wrongly refused to take
            delivery of the Goods or you weren’t present to take delivery of
            them, at the point in time where we attended your premises (or other
            delivery location) to attempt to make delivery to you.
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>8.2. </strong> Where payment for the Goods has been made by
          you in advance in full and cleared funds, the property in the Goods
          shall pass to you upon delivery. In all other cases then even if the
          Goods have been delivered and risk in them has passed to you, then the
          property in the Goods shall remain with us and shall not pass to you
          until we have received in cash or cleared funds payment in full of the
          price of the Goods under the Contract and all other money owing from
          you to us on any other account. This does not affect any of our other
          rights under the Contract.
        </p>
        <p className={classes.paragraph}>
          <strong>8.3. </strong> Until such time as the property in the Goods
          passes to you, you shall hold the Goods on our behalf, and shall keep
          the Goods separate from your own or those of third parties and
          properly stored, protected and insured and identified as our property.
          Until that time, you shall be entitled to resell or use the Goods in
          the ordinary course of your business, although this right will
          automatically stop should any of the events set out in clause 10
          (Termination) occur. If one of these clause 10 events happens, we
          shall be entitled to require you to transfer to us all rights we may
          have against the person to whom the Goods have been re-sold.
        </p>
        <p className={classes.paragraph}>
          <strong>8.4. </strong> Until the time when the property in the Goods
          passes to you (and as long as the Goods are still in existence and
          have not been resold), we shall be entitled at any time to require you
          to deliver up the Goods to us and, if you fail to do so immediately,
          we may enter upon any of your premises or those of any third party
          where the Goods are stored and repossess the Goods. We may also
          dismantle the Goods or detach them from any items in which they have
          been incorporated, and charge you all costs incurred in so doing and
          any reduction in the value of the Goods suffered by us. If you do
          re-sell the Goods, and we cannot recover them or the value of them,
          all monies owing by you to us shall (without limiting our other
          options to protect ourselves from this situation) immediately become
          due and payable.
        </p>
        <h2 className={classes.subheading}>9. Warranties</h2>
        <p className={classes.paragraph}>
          <strong>9.1. </strong> All Goods we sell are covered by warranty
          protection. Subject to the conditions set out below, the scope of the
          warranty protection available to you for the Goods will be as set out
          on the relevant product page(s) of the website for each type of the
          Goods, or if not set out on the Website, in accordance with the
          specification for the Goods in question.
        </p>
        <p className={classes.paragraph}>
          <strong>9.2. </strong> In most cases, the benefit of the
          manufacturer’s (or other third-party supplier’s) warranty will be
          passed on to you by us and you can contact the manufacturer (or other
          third party) direct for warranty services or enquiries. Please note
          that such warranty cover is offered to you by the third party and does
          not affect the terms of the Contract in any way.
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>9.3. </strong> In cases where we offer warranty protection to
          you directly, the provisions of these Conditions apply to any claim
          you may have for defective / faulty Goods and the cover we offer on
          those Goods. Any warranty protection we offer to you for Goods
          supplied is given subject to the following conditions:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>9.3.1. </strong> we shall be under no liability under the
            above warranty (or any other warranty, condition or guarantee) if
            the total price of the Goods has not been paid by the due date for
            payment; and
          </p>

          <p className={classes.paragraph}>
            <strong>9.3.2. </strong> the above warranty does not extend to
            parts, materials or equipment which we have not manufactured, and
            you shall only be entitled to the benefit of any warranty or
            guarantee given by the manufacturer of those Goods
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>9.4. </strong> Any claim by you which relates to Goods on
          which we offer warranty protection and which is based on any defect in
          their quality or condition or their failure to correspond with
          specification, shall (whether or not delivery is refused by you) be
          notified to us within two (2) working days from the date of delivery
          (or where a warranty period is offered, within two (2) working days of
          the defect in the Goods arising where the same is within the relevant
          warranty period).
        </p>
        <p className={classes.paragraph}>
          <strong>9.5. </strong> Any claim by you which relates to Goods on
          which we offer warranty protection and which is based on any defect in
          their quality or condition or their failure to correspond with
          specification, shall (whether or not delivery is refused by you) be
          notified to us within two (2) working days from the date of delivery
          (or where a warranty period is offered, within two (2) working days of
          the defect in the Goods arising where the same is within the relevant
          warranty period).The scope of your warranty protection for the Goods
          is as set out in these Conditions and the Contract. You agree as part
          of the Contract between us and you that any other warranties,
          conditions or terms that might otherwise apply to the Goods are
          excluded from the Contract.
        </p>
        <p className={classes.paragraph}>
          <strong>9.6. </strong> You will always afford us reasonable
          opportunity to remedy at our own cost any breach of the Contract for
          which we may be considered responsible.
        </p>
        <h2 className={classes.subheading}>10. Termination</h2>
        <p className={classes.paragraph}>
          <strong>10.1. </strong> If you:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>10.1.1. </strong> breach any of these Conditions or any
            other term of the Contract; or
          </p>

          <p className={classes.paragraph}>
            <strong>10.1.2. </strong> fall within the provisions of clause 4.10
            above; or
          </p>
          <p className={classes.paragraph}>
            <strong>10.1.3. </strong> make or offer to make any composition or
            arrangement with or for the benefit of your creditors or become
            subject to an administration order or (being an individual, firm or
            partnership) commit any act of bankruptcy or (being a company) go
            into liquidation (otherwise than for the purposes of amalgamation or
            reconstruction); or
          </p>

          <p className={classes.paragraph}>
            <strong>10.1.4. </strong> have an encumbrancer take possession, or a
            receiver appointed, of any of your property or assets; or
          </p>

          <p className={classes.paragraph}>
            <strong>10.1.5. </strong> have a resolution passed for your winding
            up; or
          </p>

          <p className={classes.paragraph}>
            <strong>10.1.6. </strong> cease, or threaten to cease, to carry on
            business; or
          </p>

          <p className={classes.paragraph}>
            <strong>10.1.7. </strong> are unable to pay your debts as they fall
            due; or
          </p>

          <p className={classes.paragraph}>
            <strong>10.1.8. </strong> experience any event similar to those set
            out above; or
          </p>

          <p className={classes.paragraph}>
            <strong>10.1.9. </strong> give us good reason to suspect that you
            are about to have any of the events mentioned above happen to you
            and we tell you of this reasonable suspicion;
          </p>
        </div>
        <p className={classes.paragraph}>
          then, without limiting our other options to protect ourselves from
          these situations, we shall be entitled (with or without notice to you)
          to cancel the Contract or suspend any further deliveries under the
          Contract without any liability to you. At our option, we shall also be
          entitled to invoice you immediately for all work done (or Goods
          delivered) under the Contract (or any other contract with you) and all
          invoices and other sums due to us will be due and payable immediately,
          even if we have a previous agreement or arrangement with you to the
          contrary, and we shall have the right to access your premises, and
          retrieve our Goods.
        </p>
        <p className={classes.paragraph}>
          <strong>10.2. </strong> We may cancel the Contract with you at any
          time if:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>10.2.1. </strong> you do not make any payment to us when it
            is due;
          </p>

          <p className={classes.paragraph}>
            <strong>10.2.2. </strong> you fail to provide us with information
            that is necessary for us to provide the products within a reasonable
            period of time; or
          </p>
          <p className={classes.paragraph}>
            <strong>10.2.3. </strong> you do not permit us to deliver the
            products to you within a reasonable period of time.
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>10.3. </strong> You must compensate us if you break the
          Contract. If we terminate the Contract due to the circumstances set
          out in clause 10.1 we will refund any money you have paid in advance
          for products we have not supplied but we may deduct or charge you
          reasonable compensation for the net costs we will incur as a result of
          your breaking of the Contract.
        </p>
        <p className={classes.paragraph}>
          <strong>10.4. </strong> If you wish to end your Contract with us, your
          rights when you end the Contract will depend on a number of factors
          including whether you are a business customer or a consumer, what you
          have bought, whether the Goods are faulty, when you decide to end the
          Contract and our level of performance. You may have a legal right to
          end the Contract if:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>10.4.1. </strong> the Goods you have purchased are faulty or
            incorrectly described
          </p>

          <p className={classes.paragraph}>
            <strong>10.4.2. </strong> you want to terminate the Contract because
            of something we have done or have told you we are going to do or;
          </p>
          <p className={classes.paragraph}>
            <strong>10.4.3. </strong> you are a consumer and have changed your
            mind about the Goods
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>10.5. </strong> If you are ending a Contract for one of the
          reasons listed below, the Contract will end immediately and we will
          issue a full refund or credit for any Goods which have not been
          provided:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>10.5.1. </strong> we have notified you about a change to the
            Goods which you do not agree to
          </p>

          <p className={classes.paragraph}>
            <strong>10.5.2. </strong> we have notified you about an error in the
            price or description of the Goods you have ordered and you no longer
            wish to proceed with the order;
          </p>
          <p className={classes.paragraph}>
            <strong>10.5.3. </strong> there is a risk that delivery of the Goods
            may be significantly delayed due to events outside our control;
          </p>
          <p className={classes.paragraph}>
            <strong>10.5.4. </strong> we have suspended supply of the Goods; or
          </p>
          <p className={classes.paragraph}>
            <strong>10.5.5. </strong> you have a legal right to end the Contract
            because of something we have done wrong.
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>10.6. </strong> If you are a consumer, you have a legal right
          to change your mind within 30 days of the date of your receipt of the
          Goods. During this time period (the ‘cooling off’ period) you are
          entitled to request the cancellation of your order, arrange for the
          return of the Goods and a refund. Note that this right does not apply
          to certain Goods – see 10.7.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>10.6.1. </strong> If you return unwanted Goods for a refund
            during the ‘cooling off’ period, a monetary deduction can be made if
            the value of the Goods has been reduced as a result of you using the
            Goods or handling the Goods more than was necessary. The extent to
            which you can handle the Goods is the same as it would be if you
            were assessing them in a shop.
          </p>

          <p className={classes.paragraph}>
            <strong>10.6.2. </strong> You must arrange for the Goods to be
            returned to us within 30 days of the date you notify us of your wish
            to return the Goods. We recommend you get proof of postage if you
            choose to return the Goods yourself rather than ask us to arrange a
            collection.
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>10.7. </strong> Your right as a consumer to change your mind
          does not apply in respect of:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>10.7.1. </strong> digital content once you have started to
            download this content;
          </p>
          <p className={classes.paragraph}>
            <strong>10.7.2. </strong> CDs, DVDs and sealed computer software
            where the seal has been broken;
          </p>{" "}
          <p className={classes.paragraph}>
            <strong>10.7.3. </strong> electronic licenses and support contracts
            that you have registered or activated;
          </p>{" "}
          <p className={classes.paragraph}>
            <strong>10.7.4. </strong> custom built and configured to order
            hardware products;
          </p>{" "}
          <p className={classes.paragraph}>
            <strong>10.7.5. </strong> tailor-made products such as a laptop you
            have asked us to customize by installing additional software
          </p>
        </div>
        <h2 className={classes.subheading}>
          11. Problems with goods – your rights as a consumer
        </h2>
        <p className={classes.paragraph}>
          <strong>11.1. </strong> Goods we supply to you must be advertised
          accurately, of satisfactory quality and fit for purpose. If the Goods
          we supplied to you do not comply with these criteria, you are legally
          entitled to the following courses of action:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>11.1.1. </strong> up to 30 days from the date you receive
            the Goods you can obtain a full refund
          </p>
          <p className={classes.paragraph}>
            <strong>11.1.2. </strong> up to 6 months from the date you receive
            the Goods you can get a repair or replacement. If a repair or
            replacement is not possible, you will normally be entitled to a full
            refund instead
          </p>{" "}
          <p className={classes.paragraph}>
            <strong>11.1.3. </strong> up to 6 years from the date you receive
            the Goods you may be entitled to money back if your Goods don’t last
            a reasonable length of time but after the first six months (from
            date of receipt of the Goods) the onus is on you to prove a fault
            was present at the time you took ownership of the Goods.
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>11.2. </strong> Any Goods you receive from us that do not
          comply with clause 11.1 above must be notified to us within 30 days of
          the delivery date. You can contact online at{" "}
          <Link to="https://techmatter.co.uk/return-refund-policy">
            https://techmatter.co.uk/return-refund-policy
          </Link>{" "}
          by email at{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>{" "}
          or by phone on <Link to="tel:+442031293546">+442031293546</Link>
        </p>
        <p className={classes.paragraph}>
          <strong>11.3. </strong> In relation to faulty digital, electronic and
          customized goods as set out in clause 10.7 above:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>11.3.1. </strong> if the Goods are faulty, you are entitled
            to a repair or a replacement
          </p>
          <p className={classes.paragraph}>
            <strong>11.3.2. </strong> if we cannot repair or replace the Goods
            or we fail to do so within a reasonable amount of time or we cause
            you significant inconvenience, you can get a partial and, in some
            cases, a full refund
          </p>{" "}
          <p className={classes.paragraph}>
            <strong>11.3.3. </strong> if you can demonstrate that a fault with
            your Goods has caused damage which is attributable to a lack of
            reasonable care or skill by us, you may be entitled to a repair or
            compensation
          </p>
        </div>
        <h2 className={classes.subheading}>
          12. Problems with goods – your rights as a business
        </h2>
        <p className={classes.paragraph}>
          <strong>12.1. </strong> If you are a business customer we warrant that
          Goods we supply to you shall conform in all material respects with
          their description and associated specification and be free from
          material defects in design, material and workmanship.
        </p>
        <p className={classes.paragraph}>
          <strong>12.2. </strong> If Goods we supply do not comply with the
          criteria set out in clause 12.1 and:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>12.2.1. </strong> you give us notice in writing within 48
            hours of the date of delivery;
          </p>
          <p className={classes.paragraph}>
            <strong>12.2.2. </strong> you give us a reasonable opportunity to
            receive and inspect the Goods and;
          </p>{" "}
          <p className={classes.paragraph}>
            <strong>12.2.3. </strong> you return the Goods to us at our cost,
          </p>
        </div>
        <p className={classes.paragraph}>
          we will at our discretion repair or replace the Goods or we may
          instead issue a full refund or credit. You can contact online at{" "}
          <Link to="https://techmatter.co.uk/return-refund-policy">
            https://techmatter.co.uk/return-refund-policy
          </Link>{" "}
          by email at{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>{" "}
          or by phone on <Link to="tel:+442031293546">+442031293546</Link>
        </p>
        <p className={classes.paragraph}>
          <strong>12.3. </strong> We will not be liable for any failure of Goods
          to comply with the criteria set out in clause 12.1 if:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>12.3.1. </strong> you fail to notify us of the defect in
            accordance with 12.2 above;
          </p>
          <p className={classes.paragraph}>
            <strong>12.3.2. </strong> you make any further use of the Goods
            after providing notice in accordance with clause 12.2;
          </p>{" "}
          <p className={classes.paragraph}>
            <strong>12.3.3. </strong> a defect arises which stems from fair wear
            and tear, intentional damage, negligence, unsuitable storage
            conditions, abnormal working conditions, failure to follow our
            instructions (whether oral or in writing), misuse or alteration or
            repair of the Goods without our approval;
          </p>
          <p className={classes.paragraph}>
            <strong>12.3.4. </strong> a defect arises from any drawing, design,
            specification or instruction supplied by you;
          </p>
          <p className={classes.paragraph}>
            <strong>12.3.5. </strong> a defect arises as a result of the
            location in which the Goods are to be used, or for their method of
            installation, use or maintenance, nor for any failure to correspond
            with any specification where a failure to use the Goods in a
            suitable location or by competent operators or from improper
            installation, use or maintenance has caused the fault.
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>12.4. </strong> Except as provided in this clause 12, we shall
          have no liability to you in respect of the failure of Goods to comply
          with the warranty set out in clause 12.1.
        </p>
        <p className={classes.paragraph}>
          <strong>12.5. </strong> These terms shall apply to any repaired or
          replacement Goods supplied by us under clause 12.2.
        </p>
        <p className={classes.paragraph}>
          <strong>12.6. </strong> No claim for loss of or damage to Goods in
          transit will be considered by us unless notice in writing is given to
          both the carrier concerned and to us within forty-eight (48) hours of
          delivery (or the due date for delivery in the case of lost Goods)
          followed immediately by a detailed and complete claim in writing.
        </p>
        <p className={classes.paragraph}>
          <strong>12.7. </strong> Incorrect orders – If goods are ordered in
          error (whether because too many or too few were ordered or the wrong
          item was ordered) then a return will be considered subject to the
          Goods being in the condition in which it they were received by you and
          the return request being submitted to us within 30 days of delivery.
          Returns requests received outside of this period will not normally be
          accepted.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>12.7.1. </strong> In the case of Goods which have been
            specially ordered, custom built or otherwise tailored to your
            specific requirements, a return is not usually considered. However,
            you can still submit a returns request via our Website. We will
            review each case and may be able to offer a return subject to a
            higher re-stocking fee.
          </p>
        </div>
        <h2 className={classes.subheading}>
          13. Damage and loss – your rights as a consumer
        </h2>
        <p className={classes.paragraph}>
          <strong>13.1. </strong> We are responsible to you for foreseeable loss
          and damage caused by us. If we fail to perform our obligations under
          the Contract, we are responsible for loss or damage you suffer that is
          a foreseeable result of our breaking this Contract but we are not
          responsible for any loss or damage that is not foreseeable.
        </p>
        <p className={classes.paragraph}>
          <strong>13.2. </strong> Nothing in these Conditions will limit or
          exclude our liability for death or personal injury resulting from our
          negligence or that of our servants or agents, for their fraudulent
          misrepresentation or for any other matter for which liability cannot
          be limited or excluded by operation of law. This includes your legal
          rights in relation to the Goods including the right to receive
          products which are: supplied as described and match information we
          provided to you and any sample or model seen or examined by you; of
          satisfactory quality; fit for any particular purpose made known to us;
          supplied with reasonable skill and care; and for defective products
          under the Consumer Protection Act 1987.
        </p>
        <p className={classes.paragraph}>
          <strong>13.3. </strong> If defective digital content which we have
          supplied damages a device or digital content belonging to you and this
          damage is caused by our failure to use reasonable care and skill we
          will either repair the damage or pay you reasonable compensation.
          However, we will not be liable for damage which was caused by you
          failing to correctly follow installation instructions or for your
          failure to have in place the minimum system requirements advised by
          us. Furthermore, we will not be responsible for damage which you could
          have avoided by following our advice to apply a software patch or
          update offered to you free of charge.
        </p>
        <p className={classes.paragraph}>
          <strong>13.4. </strong> We are not liable for business losses. If you
          are a consumer we only supply the Goods to you for domestic and
          private use. If you use the products for any commercial, business or
          re-sale purpose our liability to you will be limited as set out in
          clause 14.
        </p>
        <h2 className={classes.subheading}>
          14. Damage and loss – your rights as a business
        </h2>
        <p className={classes.paragraph}>
          <strong>14.1. </strong> Subject to clauses 14.3 and 14.4 below, our
          total liability under the Contract shall be limited to the extent of
          any loss, damages, injury, expenses, costs (including reasonable legal
          costs) that are directly caused by our failure to perform our
          obligations under it and in any event, the total aggregate limit of
          our liability under the Contract whether under contract, tort or any
          other legal basis is limited to the price agreed to be paid for the
          Goods which are the subject of any relevant claim or claims.
        </p>
        <p className={classes.paragraph}>
          <strong>14.2. </strong> Subject to clause 14.3 below, we are not
          liable for any claims for indirect or consequential injury, loss or
          damage (including, but not limited to loss of profit, loss of
          production, loss of opportunity and special damages and whether the
          likelihood of such loss or damage is notified by you to us before
          entering into the Contract or not) whether in contract or in tort
          (including negligence on our part, or that of our servants or agents)
          arising out of or in connection with the Contract.
        </p>
        <p className={classes.paragraph}>
          <strong>14.3. </strong> Nothing in these Conditions will limit or
          exclude our liability for death or personal injury resulting from our
          negligence or that of our servants or agents, for their fraudulent
          misrepresentation or for any other matter for which liability cannot
          be limited or excluded by operation of law.
        </p>
        <p className={classes.paragraph}>
          <strong>14.4. </strong> Except to the extent expressly stated in
          clause 14.3 all terms implied by sections 13 to 15 of the Sale of
          Goods Act 1979 and sections 3 to 5 of the Supply of Goods and Services
          Act 1982 are excluded.
        </p>
        <p className={classes.paragraph}>
          <strong>14.5. </strong> You recognize that the limitation of liability
          clauses contained in these Conditions are reasonable and that the
          prices quoted by us are dependent upon such limitations being included
          within the Contract.
        </p>
        <p className={classes.paragraph}>
          <strong>14.6. </strong> We shall not be liable to you or be in breach
          of the Contract because of any delay in performing, or any failure to
          perform, any of our obligations in relation to the Goods, if the delay
          or failure was due to any circumstance beyond our reasonable control
          (including, but not limited to, acts of God, war, acts of foreign
          enemies, terrorism, revolution, riot, civil commotion, fire, flood or
          other natural disaster or radioactive contamination). If such an event
          occurs and it prevents performance by us under the Contract, the time
          period for performance shall be extended for the duration of that
          event, save that if that same event continues to affect performance
          under the Contract for a period of more than six (6) months, You shall
          be entitled to cancel the Contract without further liability to us.
        </p>
        <h2 className={classes.subheading}>15. Returning goods to us</h2>
        <p className={classes.paragraph}>
          <strong>15.1. </strong> In all cases where Goods are to be returned to
          us, you must submit to us your returns request by submitting a returns
          form via our Website or emailing{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>{" "}
          to begin the returns process (in each case within the timeframes set
          out below). If we accept your return request, we will issue you with
          an RMA number. No returns claim will be accepted unless you are in
          possession of a valid RMA number issued by us through this process.
        </p>
        <p className={classes.paragraph}>
          <strong>15.2. </strong> Any Goods you return to us should be returned
          packaged securely in their original packaging with all accessories and
          documentation. If you do not have the original packaging, you must
          ensure the Goods are packaged in a way to avoid potential damage in
          transit.
        </p>
        <p className={classes.paragraph}>
          <strong>15.3. </strong> Goods you return to us must not be marked,
          defaced, damaged, altered or otherwise be returned to us in a
          condition which makes them unfit for re-sale (except for defects /
          faults which were present in the Goods upon issue by us). The RMA
          number we issue when arranging the return should be clearly visible on
          a label on the outer packaging.
        </p>
        <p className={classes.paragraph}>
          <strong>15.4. </strong> We may reject the return of any Goods that do
          not comply with the requirements of this clause (Clause 15). If we
          accept the return of such Goods (which will be at our sole discretion)
          then we reserve the right to charge a re-stocking / handling fee and
          deduct this fee from any refund or credit we may issue to you.
        </p>
        <p className={classes.paragraph}>
          <strong>15.5. </strong>Where any Goods are to be returned to us, you
          are responsible for the Goods and will retain the risk in the same
          until such time as they have been returned to our premises (or those
          of any relevant third party). Unless we arrange their collection via
          our own carriers, we are not liable for any damage or loss in transit
          of Goods returned to us. Unless we state in writing that it is our
          expense, the cost of returning any goods to us is at your expense.
        </p>
        <p className={classes.paragraph}>
          <strong>15.6. </strong> For all returns claims, the cost of any
          transport of Goods from us to you will only be covered by us where our
          error caused the need for the return or where the Goods supplied by us
          have been tested and found to be faulty/defective through no fault of
          your own. Other such costs are at your expense.
        </p>
        <p className={classes.paragraph}>
          <strong>15.7. </strong> If returned goods are found to have no faults
          (or have incurred faults / damage which are clearly caused through
          improper handling or usage other than by us) we may;
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>15.7.1. </strong> contact you to arrange for the Goods to be
            returned to you. In this instance, you will be liable for the
            associated delivery costs.
          </p>
        </div>
        <p className={classes.paragraph}>
          <strong>15.8. </strong> Return requests for custom made or built to
          order products will not normally be accepted. Such products are
          identified as ‘NON-RETURNABLE’ on our sales quotations and associated
          order related documents which you are privy to prior to placing an
          order with us. Faulty or defective custom/build to order products will
          be processed in accordance with Clauses 11 and 12 above.
        </p>
        <p className={classes.paragraph}>
          <strong>15.9. </strong> For business customers, return requests will
          not be accepted from any customer whose account or accounts have been
          suspended for any reason.
        </p>
        <h2 className={classes.subheading}>16. Business export terms</h2>
        <p className={classes.paragraph}>
          <strong>16.1. </strong> In these Conditions ‘Incoterms’ means the
          international rules for the interpretation of trade terms of the
          International Chamber of Commerce as in force at the date when the
          Contract is made. Any term or expression which is defined in or given
          a particular meaning by the provisions of Incoterms shall have the
          same meaning in these Conditions, but if there is any conflict between
          the provisions of Incoterms and these Conditions, these Conditions
          shall prevail.
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>16.2. </strong> Where the Goods are supplied for export from
          the United Kingdom, the provisions of this clause 15 shall (subject to
          any Special Conditions) apply over any other conflicting provision of
          these Conditions.
        </p>
        <p className={classes.paragraph}>
          <strong>16.3. </strong> You shall be responsible for complying with
          any legislation or regulations governing the importation of the Goods
          into the country of destination and for the payment of any duties on
          it.
        </p>
        <p className={classes.paragraph}>
          <strong>16.4. </strong> Unless we have agreed in writing that we will
          not, we shall always deliver to the address stipulated within the
          Contract.
        </p>
        <p className={classes.paragraph}>
          <strong>16.5. </strong> Payment of all amounts due to us will be made
          to our bank and will be confirmed by the method we have agreed with
          you that we will accept from that bank.
        </p>
        <h2 className={classes.subheading}>17. General terms</h2>
        <p className={classes.paragraph}>
          <strong>17.1. </strong> Any notice that either we or you are required
          or permitted to give to the other under these Conditions shall be in
          writing addressed to that other party at its registered office or
          principal place of business or such other address as may at the
          relevant time have been notified pursuant to this provision to the
          party giving the notice.
        </p>
        <p className={classes.paragraph}>
          <strong>17.2. </strong> No waiver by us of any breach of the Contract
          by you shall be considered as a waiver of any subsequent breach of the
          same or breach of any other provision.
        </p>{" "}
        <p className={classes.paragraph}>
          <strong>17.3. </strong> If at any time any provision of the Conditions
          is held by any competent authority to be or becomes invalid or
          enforceable in whole or in part, we agree that it will be removed from
          the Contract and the other provisions of these Conditions and the
          remainder of the provision in question shall remain in force without
          it.
        </p>
        <p className={classes.paragraph}>
          <strong>17.4. </strong> These Conditions and every Contract to which
          they apply shall be governed by the laws of England, and the parties
          agree to submit to the exclusive jurisdiction of the English courts.
        </p>
        <h2 className={classes.subheading}>18. Group companies</h2>
        <p className={classes.paragraph}>
          <strong>18.1. </strong> We may, at our sole discretion, perform any of
          our obligations or exercise any of our rights under the Contract by
          ourselves or through any other member of our group of companies.
          However, we shall still be responsible for the act or omission of the
          other member of our group of companies.
        </p>
        <h2 className={classes.subheading}>19. Assignment</h2>
        <p className={classes.paragraph}>
          <strong>19.1. </strong> The Contract is personal to you and you may
          not transfer to a third party any of your rights or your obligations
          under the Contract without our prior written consent. We shall be
          entitled to transfer any of our rights or obligations under the
          Contract at any time without your prior written consent.
        </p>
        <h2 className={classes.subheading}>
          20. Confidentiality, data protection and data security
        </h2>
        <p className={classes.paragraph}>
          <strong>20.1. </strong> You shall not use for any purpose nor disclose
          to any third party any confidential matters relating to us, any order
          or quotation or the existence of the Contract (including any
          communications relating to the Contract) without the prior written
          consent of one of our authorized representatives, which consent shall
          be given or withheld at our sole discretion.
        </p>
        <p className={classes.paragraph}>
          <strong>20.2. </strong> You and we shall, in the performance of our
          respective obligations under the Contract, comply with all laws and
          other regulatory provisions applicable to it (including, without
          limitation, any obligations set out in the Data Protection Act 1998).
          You should note the terms set out in our Privacy Policy and Website
          Terms of Use which apply to any use of the Website. We will only use
          your personal information as set out in our Privacy Policy located on
          our website.
        </p>
        <p className={classes.paragraph}>
          <strong>20.3. </strong> You acknowledge that wherever Goods are
          supplied or returned to us after they have been used (whether they are
          sent to us for repair, as a return or otherwise), it is Your
          responsibility to ensure that any data or other information stored on
          such Goods is backed up prior to being sent to Us. We shall have no
          liability to you for the corruption or loss of any data or other
          information stored or held on such Goods however it happens.
        </p>
      </div>
    </>
  );
}
